<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button mat-button routerLink="/"><h1>Darwins Reisen</h1></button>
    <span style="flex: 1 1 auto;"></span>
    <app-signin-button *ngIf="service.env.signInEnabled"></app-signin-button>
  </mat-toolbar-row>

  <mat-toolbar-row style="height: 40px">
    <button mat-button routerLink="/wintersportreisen">Wintersport</button>
    <button mat-button routerLink="/kitereisen">Kite / Snowkite</button>
    <button mat-button routerLink="/download">Download</button>
  </mat-toolbar-row>

  <mat-toolbar-row style="height: 40px" *ngIf="service.userIsAdmin | async">
    <button mat-button routerLink="/admin/kunde">Kunde</button>
    <button mat-button routerLink="/admin/reise">Reise</button>
    <button mat-button routerLink="/admin/kapazitaet">Kapazität</button>
    <button mat-button routerLink="/admin/abrechnung">Abrechnung</button>
    <button mat-button routerLink="/admin/protokoll">Protokoll</button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="app-content">
  <mat-card>
    <mat-card-content>
      <router-outlet></router-outlet>
    </mat-card-content>
  </mat-card>
</div>

<br>
<table style="margin: auto; border-spacing: 8px; border-collapse: separate;">
  <tr>
    <td>
      <button mat-button routerLink="/kontakt"><div class="mat-caption">Kontakt</div></button>
    </td>
    <td>
      <button mat-button routerLink="/impressum"><div class="mat-caption">Impressum</div></button>
    </td>
    <td>
      <button mat-button routerLink="/datenschutz"><div class="mat-caption">Datenschutzerklärung</div></button>
    </td>
  </tr>
  <tr>
    <td colspan="3" style="text-align: center">
      <span class="mat-caption">Copyright © 2017-2025 by Matthias Jung. All rights reserved.</span>
    </td>
  </tr>
</table>
